import React, {useContext} from 'react';
import {View} from 'react-native';
import {Components, Theme} from '@oneamerica/dxp-ui-components';
import responsiveStyle from './style';
import InfoWrapper from '../../../../components/InfoWrapper/InfoWrapper';
import {useSelector} from 'react-redux';
import BreakpointConstants from '../../../../constants/BreakpointConstants';
import {formatDate} from '../../../../utils';

interface LoanInformationDataProps {
  title: string;
  value: string;
}

interface LoanInformationProps {
  policyLoanData: LoanInformationDataProps[];
  loanHighlightedData: LoanInformationDataProps[];
  loansAsOfDate: string;
}
const LoanInformation = ({
  policyLoanData,
  loanHighlightedData,
  loansAsOfDate,
}: LoanInformationProps) => {
  const {...policyData} = useSelector((state: any) => state.policies);

  const loanHighlights =
    policyData.getPoliciesListData?.data?.policySummary?.policyHighlights[0];

  const {width} = useContext(Theme.ResponsiveContext);
  const isMobile = !BreakpointConstants.isMD(width);

  const style = responsiveStyle();

  return (
    <View>
      {loanHighlights?.accountConfig?.allowLoanCard ? (
        <View className="w-full p-0 mt-8">
          <View style={style.cardShadow}>
            <View className="flex-col lg:flex-row lg:items-center">
              <Components.Text.H3 style={[style.cardHeaderTitle, style.flex]}>
                Loan Information
              </Components.Text.H3>
              {loansAsOfDate ? (
                <Components.Text style={style.loanAsOfDate}>
                  Loan information as of{' '}
                  {formatDate(loansAsOfDate, 'MMM DD, YYYY', '-')}
                </Components.Text>
              ) : null}
            </View>
            <View className="mt-4" style={style.horizontalDivider} />
            <View
              className="my-4 px-4 py-4"
              style={style.blueContainerLoanCard}>
              <View
                style={{
                  flex: 1,
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                }}
                className="w-full">
                {loanHighlightedData
                  .filter((data) => data?.title && data?.value)
                  .map((data, index) => (
                    <View
                      key={`${data.title}-${index}`}
                      className="w-full sm:w-full md:w-1/3 lg:w-1/4 border-b-[0.5px] border-[#d6d6d6] md:border-b-0">
                      <InfoWrapper
                        responsive
                        title={data.title}
                        subTitle
                        information={data.value || '-'}
                        titleTextStyle={{
                          fontSize: isMobile ? 16 : 20,
                        }}
                        infoTextStyle={{
                          fontWeight: '500',
                        }}
                      />
                    </View>
                  ))}
              </View>
            </View>
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
              className="w-full -my-4 md:my-0">
              {policyLoanData.map((data, index) => {
                return (
                  <View
                    key={`${data.title}-${index}`}
                    className={`w-full sm:w-full md:w-1/4 lg:w-1/4 pt-4 md:py-0${index > 0 ? ' border-t-[0.5px] border-[#d6d6d6] md:border-t-0' : ''}`}>
                    <InfoWrapper
                      responsive
                      title={data.title}
                      subTitle
                      information={data.value || '-'}
                      infoTextStyle={{
                        fontWeight: '500',
                      }}
                    />
                  </View>
                );
              })}
            </View>
          </View>
        </View>
      ) : null}
    </View>
  );
};

export default LoanInformation;
